import React, { useState } from "react";
import { useNavigate } from "react-router-dom";

const validClientCodes = [
  "CPXINT",
  "ABWLNS",
  "M42HLTH",
  "TECHBBQ",
  "CPXWELC",
  "VITLYST",
  "BURJHLD",
  "CPMUND",
  "PROME",
  "CPDEMO1",
  "CPDEMO3",
  "PRUIB",
  "IINTSC",
  "KRAOS",
  "REVASE",
  "GMK",
  "PERFIOS",
  "QUBE1026",
];

export default function VerifyClientCode() {
  const [clientCode, setClientCode] = useState("");
  const [error, setError] = useState("");
  const navigate = useNavigate();

  const handleVerify = () => {
    const trimmedCode = clientCode.trim();

    if (!trimmedCode) {
      setError("Please enter a client code");
      return;
    }

    if (!validClientCodes.includes(trimmedCode.toUpperCase())) {
      setError("Please enter a valid client code");
      return;
    }

    setError("");
    navigate("/derma-start", { state: { clientCode: trimmedCode } });
  };

  return (
    <div className="min-h-screen flex flex-col justify-between bg-black px-6 py-10">
      {/* Top Spacer */}
      <div className="w-[70%] h-64 mx-auto -mt-56 blur-[100px] bg-gradient-to-b from-[#A7D4FF] via-[#A7D4FF] to-[#4A6394] rounded-b-full"></div>

      {/* Input Section */}
      <div className="flex flex-col ">
        <div className="text-white text-sm mb-2">ENTER CLIENT CODE</div>
        <input
          type="text"
          value={clientCode}
          onChange={(e) => setClientCode(e.target.value.toUpperCase())}
          placeholder="Enter Client Code"
          className="w-full max-w-sm py-3 px-6 rounded-xl border outline-none  text-sm text-gray-900"
          style={{ borderColor: error ? "red" : "#A6FF96" }}
        />
        {error && <p className="text-red-500 text-sm mt-2">{error}</p>}
      </div>

      {/* Buttons Section */}
      <div className="flex flex-col items-center gap-4">
        <button
          onClick={handleVerify}
          className="block px-3 py-2 outline-none rounded-full bg-white text-primary text-lg w-10/12"
        >
          <span className="from-[#455C8E] via-[#455C8E] to-[#A7D4FF] bg-gradient-to-r bg-clip-text text-transparent font-medium">
            Verify Code
          </span>
        </button>

        <button
          onClick={() => setClientCode("")}
          className="text-white text-sm "
        >
          Cancel
        </button>
      </div>
    </div>
  );
}
